import React, { useCallback } from 'react'
import { setNavigatingValue, setIsClickedDashboard } from '../redux/slices/leave-page-slice';
import { useAppDispatch } from '../redux/hook';
import { useNavigate, useLocation } from 'react-router-dom';
import { P2Breadcrumb } from 'react-bootstrap-common-script';
import { useMemo } from 'react';
interface ApplicationCooLayoutProps {
  children: React.ReactNode;
  title?:string;
  description?: string;
  customPages?: BreadCrumbPage[];
}

interface BreadCrumbPage {
  title: string,
    link: string,
    action?: () => void,
    additionalAction?: () => void,
}

const routesToTriggerLeavingConfirmation: string[] = [
  "/application-coo/stage-a/eligibility",
  "/application-coo/stage-a/financing",
  "/application-coo/stage-a/conveyancing",
  "/application-coo/stage-a/upload-documents",
  "/application-coo/stage-a/summary",
];
function ApplicationCooLayout({ title = "Change in Flat Ownership", ...props }: ApplicationCooLayoutProps) {
  const AppDispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const handleBackToDashboard = useCallback(() => {
    if(routesToTriggerLeavingConfirmation.includes(location.pathname)){
        AppDispatch(setIsClickedDashboard(true));
        AppDispatch(setNavigatingValue("/"));
    }
  }, [location.pathname, navigate])

  const getAction = useMemo(() => {
    if(routesToTriggerLeavingConfirmation.includes(location.pathname)){
      return handleBackToDashboard;
    }else{
      return null;
    }
  }, [handleBackToDashboard, routesToTriggerLeavingConfirmation, location.pathname])
  
  return (
    <main className="polymer-application-coo">
      <div className="polymer-application-coo-header">
        <div className="polymer-application-coo__header-actions">
          <div className="polymer-application-coo__header-actions__back">
            <div style={{ margin: 0 }}>
              <P2Breadcrumb
                pages={
                  props.customPages
                    ? props.customPages
                    : [
                        { title: "Home", link: "https://www.hdb.gov.sg/", action: getAction },
                        { title: "Dashboard", link: "/transfer", action: getAction },
                        { title: title, link: "#", additionalAction: null },
                      ]
                }
              />
            </div>
          </div>
          {/* <FontResizingButton /> */}
        </div>
        <div className="polymer-application-coo__header-title">
          <h1>{title}</h1>
        </div>
        {props.description && (
          <div className="polymer-application-coo__header-subtitle">
            <p>{props.description}</p>
          </div>
        )}
      </div>
      <div className="polymer-application-coo__card shadow-sm">{props.children}</div>
    </main>
  );
}

export default ApplicationCooLayout